import {useGetRequestData} from './client';

export const useWiki = (feedbackCh, community, slug) =>
    useGetRequestData(feedbackCh, `/api/v2/wiki/wiki.json?community=${community}&slug=${slug}`)?.wikis[0];

export const useWikiIndex = (feedbackCh, community) =>
    useGetRequestData(feedbackCh, `/api/v2/wiki/index.json?community=${community}`)?.wikis;